import type { Example } from "~/components/shared/Examples/useExamples";
import { RepositoryInfo } from "~/components/pipeline/New/ConnectGitPicker/util/types";

function exampleToRepo(examples: Example[]): RepositoryInfo[] {
  return examples.map((example) => ({
    full_name: example.name,
    description: example.description || "",
    private: false,
    fork: false,
    language: example.languages?.[0],
    html_url: example.repository_url,
    ssh_url: example.ssh_url,
    clone_url: example.clone_url,
    default_branch: example.default_branch,
    updated_at: example.updated_at,
    visibility: "public",
    configuration: example.yaml_config,
  }));
}

export type { Example };

export default exampleToRepo;
